import React from 'react'

import { Container } from '../../components/Bootstrap'
import { Bar } from '../../components/Charts'
import Hero from '../../components/Hero'
import Layout from '../../components/Layout'
import Navigation from '../../components/Navigation'
import Summary from '../../components/Summary'

import { bold } from '../../styles'

const PartnerOne = () => (
  <Layout>
    <Hero>
      <h1>Question 1</h1>
      <p className={bold}>My primary relationship with Centre for Independent Living Toronto(CILT) is:</p>
    </Hero>
    <Container>
      <Navigation next="/partners/2" />
      <Bar
        data={{
          labels: [ 'Board Member', 'Volunteer', 'Funder', 'Staff Member', 'Community Partner', 'Consumer', 'Family Member', 'Other Stakeholder' ],
          series: [ [ 0, 0, 0, 0, 45, 0, 0, 0 ] ]
        }}
        options={{
          axisY: {
            labelInterpolationFnc: (value, index) => `${value}%`,
            onlyInteger: true,
            offset: 60,
            scaleMinSpace: 30,
          },
          height: '500px',
          width: '100%',
          high: 100,
          seriesBarDistance: 4
        }}
        caption="My primary relationship with Centre for Independent Living is Toronto (CILT) is"
        header="Percent of respondents"
      />
	  <Summary>The graph shows that all of the respondents were from the Community Partner category.</Summary>
    </Container>
  </Layout>
)

export default PartnerOne
